import React from 'react';
import { Heading as ChakraHeadingBase } from '@chakra-ui/react';

/**
 * Chakra UI版のHeadingコンポーネント
 * 既存のTailwind版と並行して使用可能
 */
const ChakraHeading = ({
  children,
  as = 'h2',
  size = 'xl',
  variant,
  color,
  textAlign,
  mb,
  ...props
}) => {
  return (
    <ChakraHeadingBase
      as={as}
      size={size}
      variant={variant}
      color={color}
      textAlign={textAlign}
      mb={mb}
      {...props}
    >
      {children}
    </ChakraHeadingBase>
  );
};

export default ChakraHeading;